//公共请求方法
import axios from "../utils/request"
import base from "./base"
import login from './login' //登录
import item from './item' //商品档案
// import order from './order' //销售订单
import store from './store' //门店档案
import order from './order' //销售订单
import home from "./home"
import bsns from "./bsns"//更新乐檬数据
import finance from "./finance"//财务
import delivery from "./delivery"//配送
import expand from "./expand"//门店地图
import administration from "./administration"//营业执照
import contacts from "./contacts"//通信录
export default {
    ...login, //登录
    ...item, //商品档案
    ...store,//门店档案
    ...order,//销售订单
    ...home,//首页
    ...bsns,//更新乐檬数据
    ...finance,//财务
    ...delivery,//配送
    ...expand,//门店地图
    ...administration,//营业执照
    ...contacts,//通信录
}